import styled from "styled-components";
import { LOGO_HOME } from "@assets";
import { PlusCircleFilled } from "@ant-design/icons";
import { SearchOutlined, DownloadFilled, SyncFilled, } from "@assets";

export const Bar = styled.div`
  min-height: 70px;
  padding-inline: 15px 16px;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: linear-gradient(0deg, #6d1d7a, #94378c);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,
    rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
  z-index: 1000;
`;

export const LogoWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%); /* Safari & Chrome */
  -moz-transform: translate(-50%, -50%); /* Firefox */
  -ms-transform: translate(-50%, -50%); /* Internet Explorer */
  -o-transform: translate(-50%, -50%); /* Opera */
`;

export const Image = styled.img.attrs({
  alt: "logo",
  src: LOGO_HOME,
})`
  max-width: 105px;
  object-fit: contain;

  @media screen and (max-width: 360px) {
    max-width: 95px;
  }

  @media screen and (max-width: 320px) {
    max-width: 85px;
  }

  @media screen and (max-width: 305px) {
    max-width: 75px;
  }

  @media screen and (max-width: 280px) {
    max-width: 70px;
  }
`;

export const BoxWrapper = styled.div`
  flex: 1;
  display: flex;
`;

export const Box = styled.div`
  min-width: 32px;
  padding: 8px 25px 8px 8px;
  display: inline;
  border-radius: 16px;
  position: relative;
  background-color: #fff;
  cursor: pointer;

  #blc-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    text-align: center;
    font-size: 10px;
    font-weight: bold;
    font-style: normal;
    letter-spacing: normal;
    color: #000;
  }

  @media screen and (max-width: 340px) {
    min-width: 27px;
    padding: 8px 21px 8px 8px;

    #blc-text {
      font-size: 8px;
    }
  }

  @media screen and (max-width: 305px) {
    min-width: 26px;
  }

  @media screen and (max-width: 290px) {
    #blc-text {
      font-size: 7px;
    }
  }
`;

export const PlusWrapper = styled.div`
  width: 32px;
  border-radius: 50%;
  background-color: ${props => props.transparent === 'true' ? 'transparent' : '#fff'};

  position: absolute;
  top: 50%;
  right: -10px;
  transform: translate(0%, -50%);
  -webkit-transform: translate(0%, -50%); /* Safari & Chrome */
  -moz-transform: translate(0%, -50%); /* Firefox */
  -ms-transform: translate(0%, -50%); /* Internet Explorer */
  -o-transform: translate(0%, -50%); /* Opera */

  @media screen and (max-width: 360px) {
    width: 30px;
    top: 51%;
  }

  @media screen and (max-width: 320px) {
    width: 28px;
    top: 53%;
  }
`;

export const ReloadIcon = styled(SyncFilled)`
margin-bottom: -3px;
`;

export const PlusIcon = styled(PlusCircleFilled)`
  color: #ff6dbc;
  font-size: 32px;

  @media screen and (max-width: 360px) {
    font-size: 30px;
  }

  @media screen and (max-width: 320px) {
    font-size: 28px;
  }

  @media screen and (max-width: 320px) {
    font-size: 28px;
  }
`;

export const IconWrapper = styled.div`
  flex: 1;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;

  svg {
    width: 22px;
    cursor: pointer;
  }

  @media screen and (max-width: 360px) {
    gap: 18px;
  }

  @media screen and (max-width: 320px) {
    gap: 16px;
  }

  @media screen and (max-width: 280px) {
    gap: 14px;
  }
`;

export const Icon = styled(SearchOutlined)`
  width: 22px !important;
  color: #fff;
  cursor: pointer;
  margin-top: 3px;

  @media screen and (max-width: 360px) {
    width: 18px !important;
  }

  @media screen and (max-width: 320px) {
    width: 16px !important;
  }

  @media screen and (max-width: 280px) {
    width: 14px !important;
  }
`;

export const SearchIcon = styled(SearchOutlined)`
  cursor: pointer;
  color: #73217d;
  width: 22px !important;

  @media screen and (max-width: 360px) {
    width: 18px !important;
  }

  @media screen and (max-width: 320px) {
    width: 16px !important;
  }

  @media screen and (max-width: 280px) {
    width: 14px !important;
  }
`;

export const Download = styled(DownloadFilled)`
  width: 22px !important;

  @media screen and (max-width: 360px) {
    width: 18px !important;
  }

  @media screen and (max-width: 320px) {
    width: 16px !important;
  }

  @media screen and (max-width: 280px) {
    width: 14px !important;
  }
`;
